<!-- Container -->
<div class="container">

  <ul>
    <li class="help-ul">
      Getting started
      <ul>
        <li>
          Use the same phone to sign up for an account and record logbook data.
          At this time, you will not see your data if you log in to a different device.
        </li>
        <li>
          Access the app at
          <a [href]="website"
             [target]="linkType">
            {{website}}
          </a>,
          then use Save to Home Screen options to download as an app for offline use.
          For more details, see the Download The App section.
        </li>
        <li>
          Create your account and confirm your email.
        </li>
      </ul>
    </li>

    <li class="help-ul">
      Logbook Data Collection
      <ul>
        <li>
          In "Sets and Catch" record set information (dates, locations, times, gear) and catch details.
        </li>
        <li>
          In "Current Delivery" record fish tickets, landing details, vessel and permit information.
          Verify the sets included in your landing here.
        </li>
      </ul>
    </li>

    <li class="help-ul">
      Logbook Submission
      <ul>
        <li>
          After landing, submit data from the link at the bottom of the "Current Delivery" page.
        </li>
        <li>
          Until you submit a logbook, the information is only stored on your phone.
        </li>
        <li>
          Submit data within 24 hours of landing.
        </li>
      </ul>
    </li>
  </ul>

</div>
